// Third-party imports
import $ from 'jquery';
import axios from 'axios';

import { showAddToCartPopup } from '../global/header.js';
import { updateCartButtonIndicator } from './updateCartIndicator.js';
import { renameProperties } from './postDonationProduct.js';
// These methods are used to post a product to the cart
// using the data from a multi-form.
// We assume that certain elements exist, and are id'ed specifically.
//
// The add button has an id: 'buttonid${cardnum}'

export function postGiftToCart(global, form, cardnum) {
    let doc = global.document;
    let variantIDHookElement = doc.getElementById(`productIDHook${cardnum}`);
    let isInCart = variantIDHookElement.dataset.inCart;
    let quantityInCart = variantIDHookElement.dataset.cartQuantity;
    //Rename propertites to add under score to hide the properties at checkout page
    renameProperties(global);
    // Used to post the product in different ways...
    // postForm - simply posts the form as is
    // postFake - shows an update popup, but doesn't post any products
    // removeAndPost - removes the product from the cart, and then posts the form
    let postType = 'postForm';

    // If the product is in the cart, we overwrite the quantity in the cart with 1,
    // unless the quantity is already 1 in the cart, then we just fake add
    if (isInCart === 'true') {
        postType = quantityInCart === 1 ? 'postFake' : 'removeAndPost';
    }

    if (postType === 'postForm') {
        postForm(global, form, false, cardnum);
    } else if (postType === 'postFake') {
        showAddToCartPopup(global, true);
    } else if (postType === 'removeAndPost') {
        removeAndReAddProduct(global, form, cardnum);
    }
}

function postForm(global, form, productInCart, cardnum) {
    setAddButtonVisible(global, cardnum, false);

    // The code below was got from the url below. This is how to post a multipart
    // form without navigating to the page
    // https://www.mkyong.com/jquery/jquery-ajax-submit-a-multipart-form/

    // Create an FormData object
    let data = new FormData(form);
    $.ajax({
        type: 'POST',
        enctype: 'multipart/form-data',
        url: '/cart/add',
        dataType: 'json',
        data: data,
        processData: false,
        contentType: false,
        cache: false,
        timeout: 5000,
        success: data => {
            // If the item was/is in the cart, we show
            // the popup as an update instead of an add
            //showAddToCartPopup(global, productInCart);

            updateCartButtonIndicator();

            setInCartDataAttributes(global, cardnum, data.quantity);
            // Show the add button after 250 ms, to avoid spam clicks
            setTimeout(() => {
                setAddButtonVisible(global, cardnum, true);
            }, 250);
        },
        error: e => {
            let err = {
                msg: 'POST failed for adding item to cart',
                data: e,
            };
            throw err;
        },
    });
}

// Removes the product from the cart, then readds it with the updated data
function removeAndReAddProduct(global, form, cardnum) {
    let product_id = global.document.getElementById(`productIDHook${cardnum}`)
        .value;

    axios
        .post('/cart/change.js', {
            id: product_id,
            quantity: 0,
        })
        .then(() => {
            postForm(global, form, true, cardnum);
        })
        .catch(error => {
            let err = {
                msg: 'Unexpected error',
                data: error,
            };
            throw err;
        });
}

function setInCartDataAttributes(global, cardnum, postedQuantity) {
    let variantElement = global.document.getElementById(
        `productIDHook${cardnum}`
    );

    variantElement.dataset.inCart = 'true';
    variantElement.dataset.cartQuantity = postedQuantity;

    let variantSelect = global.document.getElementById(`variantid${cardnum}`);
    if (variantSelect) {
        let selected = variantSelect.selectedIndex;
        let dataset = variantSelect.options[selected].dataset;
        dataset.inCart = 'true';
        dataset.cartQuantity = postedQuantity;
    }

    updateAddButtonStatus(global, cardnum);
}

export function updateAddButtonStatus(global, cardnum) {
    updateAddGiftButtonLabel(global, cardnum);
    updateButtonEnabled(global, cardnum);
    viewButtonEnabled(global, cardnum);
}

function updateAddGiftButtonLabel(global, cardnum) {
    let addButtonLabel = global.document.getElementById(
        `addButtonLabel${cardnum}`
    );
    if (!addButtonLabel) {
        return;
    }

    const inCart = isInCart(global, cardnum);
    const dataset = cardDataset(global, cardnum);
    if (dataset) {
        let label = dataset.addLabel;
        if (inCart) {
            label = dataset.alreadyInCartLabel;
        }
        addButtonLabel.innerHTML = label;
    }
}

function updateButtonEnabled(global, cardnum) {
    let add_button = global.document.getElementById(`buttonid${cardnum}`);
    let sold_out_button = global.document.getElementById(
        `soldOutbuttonid${cardnum}`
    );
    if (!add_button) {
        return;
    }

    const inCart = isInCart(global, cardnum);
    if (inCart) {
        if (!add_button.classList.contains('button--removed')) {
            add_button.classList.add('button--removed');
        }
    } else {
        if (
            add_button.classList.contains('button--removed') &&
            sold_out_button.classList.contains('button--removed')
        ) {
            add_button.classList.remove('button--removed');
        }
    }
}

function viewButtonEnabled(global, cardnum) {
    let view_button = global.document.getElementById(`viewbuttonid${cardnum}`);
    if (!view_button) {
        return;
    }

    const inCart = isInCart(global, cardnum);
    if (inCart) {
        if (view_button.classList.contains('button--removed')) {
            view_button.classList.remove('button--removed');
        }
    } else {
        if (!view_button.classList.contains('button--removed')) {
            view_button.classList.add('button--removed');
        }
    }
}

// Hide the spinner and show the add to cart button or
// Show the spinner and hide the add to cart button
function setAddButtonVisible(global, cardnum, visible) {
    let add_button = global.document.getElementById(`buttonid${cardnum}`);
    if (!add_button) {
        return;
    }

    let spinner = add_button.querySelector(`#addButtonSpinner${cardnum}`);
    let addButtonLabel = add_button.querySelector(`#addButtonLabel${cardnum}`);

    if (!spinner || !addButtonLabel) {
        return;
    }

    if (visible) {
        addButtonLabel.style.setProperty('visibility', 'visible');
        spinner.classList.add('u-hide');
    } else {
        addButtonLabel.style.setProperty('visibility', 'hidden');
        spinner.classList.remove('u-hide');
    }
}

// Returns the data-in-cart value on the card, unless there are variants
// then it returns the data-in-cart value of the selected variant
function isInCart(global, cardnum) {
    const dataset = cardDataset(global, cardnum);
    let inCart = dataset && dataset.inCart === 'true' ? true : false;
    const variantInCart = selectedVariantInCart(global, cardnum);
    inCart = variantInCart !== undefined ? variantInCart : inCart;
    return inCart;
}

// Returns the data set of the card
function cardDataset(global, cardnum) {
    let cardElement = global.document.getElementById(`productIDHook${cardnum}`);
    if (!cardElement) {
        return null;
    }
    return cardElement.dataset;
}

// Checks if there's a variant select element, and if there is, returns the data-in-cart value
function selectedVariantInCart(global, cardnum) {
    let variantSelect = global.document.getElementById(`variantid${cardnum}`);
    if (!variantSelect) {
        return;
    }
    let selected = variantSelect.selectedIndex;
    let dataset = variantSelect.options[selected].dataset;
    return dataset.inCart === 'true' ? true : false;
}
